"use client"
import { Slide } from '@/@types/Slide'
import React, { useState, useRef } from 'react'
import { FallbackImage } from '../common'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import { cn } from '@/lib/utils'

type Props = {
  slides: Slide[]
}

export const Slider = ({ slides }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const swiperRef = useRef<any>(null)

  if (!slides || slides.length === 0) {
    return null
  }

  return (
    <section className="w-full relative group overflow-hidden">
      <Swiper
        modules={[Autoplay, Pagination]}
        slidesPerView={1}
        onSlideChange={(swiper) => setCurrentIndex(swiper.activeIndex)}
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        className="w-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <a
              href={slide.link}
              target={slide.is_blank == "1" ? "_blank" : "_self"}
              className='block w-full'
            >
              <div className="relative w-full pb-[62%] lg:pb-[20%]">
                {/* Imagen para móviles */}
                <div className="absolute inset-0 lg:hidden">
                  <FallbackImage
                    width={768}
                    height={384}
                    alt={slide.alt_text || 'Slider Image'}
                    src={slide.image_responsive}
                    className="w-full h-full object-cover"
                    priority={true}
                    sizes="100vw"
                  />
                </div>

                {/* Imagen para desktop */}
                <div className="absolute inset-0 hidden lg:block">
                  <FallbackImage
                    width={1920}
                    height={384}
                    alt={slide.alt_text || 'Slider Image'}
                    src={slide.image}
                    className="w-full h-full object-cover"
                    priority={true}
                    sizes="100vw"
                  />
                </div>
              </div>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Buttons */}
      <div className="absolute bottom-4 left-4 flex space-x-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => swiperRef.current?.slideTo(index)}
            className={cn(
              'w-10 sm:w-14 h-1 rounded hover:bg-matco transition-colors duration-300',
              index === currentIndex ? 'bg-matco' : 'bg-light01'
            )}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  )
}
